<template>
  <b-card title="تب">
    <b-card-text>
      <span>در این قسمت می توانید به محتوای خود تب اضافه کنید </span>
    </b-card-text>


    <b-row>
      <b-col cols="12">
        <b-form-group
            label="نام محتوا "
        >
          <b-form-input
              placeholder="این نام داخل اپلیکیشن نمایش داده نمی شود "
              v-model="data.name"
          />
        </b-form-group>


      </b-col>

    </b-row>


    <b-form
        ref="form"
        :style="{height: trHeight}"
        class="repeater-form"
        @submit.prevent="repeateAgain"
    >


      <!-- Row Loop -->
      <b-row
          v-for="(item, index) in content.tabs"
          :id="item.id"
          :key="item.id"
          ref="row"
      >

        <!-- Item Name -->
        <b-col md="3">
          <b-form-group
              label="عنوان تب "
          >
            <b-form-input
                placeholder="این نام داخل اپلیکیشن نمایش داده می شود "
                v-model="item.tabName"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
              label="آپلود آیکون"

          >
            <b-form-file
                @change="handleChange(item, $event)"
                placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
                drop-placeholder="Drop file here..."
                accept=".jpg,.svg, .png"

            />

          </b-form-group>
        </b-col>


        <b-col md="4">

          <b-form-group
              label="انتخاب  محتوا برای تب"
          >
            <b-form-select
                v-model="item.contentId"
                :options="contents"

            />
          </b-form-group>
        </b-col>
        <!-- Remove Button -->
        <b-col
            lg="2"
            md="2"
            class="mb-50"
        >
          <!--          <b-col-->
          <!--              md="1"-->
          <!--              class="mb-50"-->
          <!--          >-->
          <!--            <b-button-->
          <!--                v-ripple.400="'rgba(234, 84, 85, 0.15)'"-->
          <!--                variant="outline-success"-->
          <!--                style="margin-top: 27.5px !important;"-->
          <!--                @click="submitItem(index)"-->
          <!--            >-->
          <!--              <feather-icon-->
          <!--                  icon="CheckIcon"-->
          <!--                  class="mr-25"-->
          <!--              />-->
          <!--              <span>ثبت</span>-->
          <!--            </b-button>-->

          <!--          </b-col>-->

          <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              style="margin-top: 27.5px;"
              @click="removeItem(index)"
          >
            <feather-icon
                icon="XIcon"
                class="mr-25"
            />
            <span>حذف</span>
          </b-button>
        </b-col>
        <b-col cols="12">
          <hr>
        </b-col>
      </b-row>

    </b-form>

    <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="repeateAgain"
    >
      <feather-icon
          icon="PlusIcon"
          class="mr-25"
      />
      <span>اضافه کردن </span>
    </b-button>


    <b-form-group>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          class="mr-1 mt-1"
          @click="SaveContent"
      >
        ثبت
      </b-button>
    </b-form-group>

  </b-card>
</template>

<script>
import {
  BFormTextarea,
  BFormSelect,
  BForm,
  BCardText,
  BRow,
  BCol,
  BImg,
  BFormFile,
  BCard,
  BFormGroup,
  BFormInput,
  BButton
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import UploadFile from '@/modules/components/upload/uploadFile'
import uploadService from "@/modules/services/uploadService";
import contentRepository from '@/modules/contents/services/contentRepository'
import {$appConfig} from "../../../../appConfig";
import {heightTransition} from "@core/mixins/ui/transition";


export default {
  components: {
    BCard,
    BButton,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BImg,
    BCardText,
    UploadFile,
    BFormFile,
    BForm,
    BFormSelect,
    BRow,
    BCol

  },
  name: "tabFormComponent",
  mixins: [heightTransition],
  props: ['content'],
  data() {
    return {
      file: undefined,
      pageLength: 15,
      totalRecords: 0,
      selectedFile: '',
      selectedContent: undefined,
      contents: [],
      imageUrl: '',
      data: {
        tabs: [],
        name: '',
      },
    }
  },

  mounted() {
    this.initTrHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
    this.getContent();
  },
  methods: {
    async submitItem() {



      this.repeateAgain();

    },
    async handleChange(item, event){
      item.imageAddress = $appConfig.endpoint.baseFileDomain + '/'+ await uploadService.upload(event.target.files["0"]);
    },
    repeateAgain() {


      console.log(this.content.tabs);


      this.content.tabs.push({
        imageAddress: '',
        contentId: '',
        tabName: '',
      })




      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.content.tabs.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    async getContent() {
      const {data} = await contentRepository.getForTab('');

      if (data.isSuccess) {
        this.contents = data.data.map((p) => {
          return {
            value: p.id, text: p.title
          }
        });
        // this.totalRecords = data.totalRecordCount;
      }
    },
    SaveContent(event) {
      let lastIndex = this.content.tabs[this.content.tabs.length-1]
      console.log(lastIndex , 'lastIndex')
      if (lastIndex.imageAddress==='' && lastIndex.contentId ===''&& lastIndex.tabName === ''){
        this.content.tabs.splice(this.content.tabs.length-1, 1)
      }
      console.log(this.content.tabs);

      this.$emit('tapFormSubmit', this.content)
    },
  },
  directives: {
    Ripple,
  },

}
</script>

<style scoped>
.ck-editor__editable {
  height: 400px !important;
}
</style>
